import { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { AuthContext } from '../../context/auth'
import { Navbar } from '../Navbar'
import { Footer } from '../Footer'
import css from './layout.module.scss'
import { FloatingCta } from '../FloatingCta'
import { SignIn } from "../../PagesV1/SignIn"
import { SignUp } from "../../PagesV1/SignUp"
import { CompleteModal } from "../modals/completeModal"
import { RestoreModal } from "../modals/restorePasswordModal"
import { OrderCompleteModal } from '../modals/orderCompleteModal'
import { ShippingAddressModal } from '../modals/shippingAddressModal'
import { BillingAddressModal } from '../modals/billingAddressModal'
import { DeleteProfileModal } from "../modals/DeleteProfileModal"
import { LogoutModal } from "../modals/LogOutModal"
import { ChangeEmailModal } from "../modals/changeEmailModal"
import { ChangePasswordModal } from "../modals/changePasswordModal"
import { ChangePasswordRestoreModal } from "../modals/changePasswordRestoreModal"
import TeamModal from '../modals/teamModal'
import ThankYouModal from '../../components/modals/ThankYouModal'
import PopupModal from '../../components/modals/PopupModal'
import UpcomingPurchaseModal from '../../components/modals/UpcomingPurchaseModal'
import BulkOrderFormModal from '../../components/modals/bulkOrderFormModal'
import CartModal from '../../components/modals/CartModal'
import Helmet from "../../components/Helmet"
import { getLocalStorage } from '../../helpers/localStorage'
import Notification from '../../components/Notification'


export const Layout = ({ children, meta }) => {
  const [showFloatingCta, setShowFloatingCta] = useState(false);
  const { user, signInModal, setSignInModal, signUpModal, setSignUpModal, completeModal, setCompleteModal, restoreModal, setRestoreModal, changePasswordModal, setChangePasswordModal, changePasswordRestoreModal, setChangePasswordRestoreModal, notification, setNotification, teamModal, setTeamModal, changeEmailModal, setChangeEmailModal, logOutModal, setLogOutModal, deleteProfileModal, setDeleteProfileModal, shippingAddressModal, setShippingAddressModal, billingAddressModal, setBillingAddressModal, completeOrderModal, setCompleteOrderModal, tempDisable, setTempDisable, openItemPreviewModal, setOpenItemPreviewModal, setSelectedProduct, setSelectedProtein, setMapViewActive, openPopupModal, setOpenPopupModal, upcomingPurchaseModal, setUpcomingPurchaseModal, bulkOrderModal, setBulkOrderModal } = useContext(AuthContext)
  const location = useLocation()

  useEffect(() => {
    if (signInModal || signUpModal || completeModal || restoreModal || changePasswordModal || changePasswordRestoreModal || teamModal || changeEmailModal || logOutModal || deleteProfileModal || shippingAddressModal || billingAddressModal || completeOrderModal || openItemPreviewModal || upcomingPurchaseModal || bulkOrderModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [signInModal, signUpModal, completeModal, restoreModal, changePasswordModal, changePasswordRestoreModal, teamModal, changeEmailModal, logOutModal, deleteProfileModal, shippingAddressModal, billingAddressModal, completeOrderModal, tempDisable, openItemPreviewModal, upcomingPurchaseModal, bulkOrderModal])


  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(null)
      }, 2500)
    }
  }, [notification])


  useEffect(() => {
    const handleBackButton = () => {
      setSignInModal(false)
      setSignUpModal(false)
      setCompleteModal(false)
      setRestoreModal(false)
      setChangePasswordModal(false)
      setChangePasswordRestoreModal(false)
      setTeamModal(false)
      setChangeEmailModal(false)
      setLogOutModal(false)
      setDeleteProfileModal(false)
      setShippingAddressModal(false)
      setBillingAddressModal(false)
      setCompleteOrderModal(false)
      setTempDisable(true)
      setOpenItemPreviewModal(false)
      setMapViewActive(false)
      setSelectedProduct(null)
      setSelectedProtein(null)
      setOpenPopupModal(false)
      setUpcomingPurchaseModal(false)
      setBulkOrderModal(false)
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", () => handleBackButton);
    }

  }, [])

  useEffect(() => {
    if (location.pathname === '/v1/login' && !getLocalStorage('identifyntoken') && !user) {
      setSignInModal(true)
    }
    if (location.pathname === '/reset') {
      setRestoreModal(true)
    }
  }, [location, user])

  useEffect(() => {
    const onScroll = () => {
      const trigger = window.innerHeight * 0.8;
      const nearFooter = window.scrollY > trigger;
      setShowFloatingCta(nearFooter);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={css.layout}>
      {<Helmet meta={meta} />}
      {notification && <Notification message={notification.message} subMessage={notification.subMessage} type={notification.type} onClick={() => setNotification(null)} />}
      <Navbar />
      <main>
        {children}
      </main>
      <Footer />
      {signInModal && <SignIn />}
      {signUpModal && <SignUp />}
      {completeModal && <CompleteModal />}
      {restoreModal && <RestoreModal />}
      {teamModal && <TeamModal />}
      {completeOrderModal && <OrderCompleteModal />}
      {shippingAddressModal && <ShippingAddressModal />}
      {billingAddressModal && <BillingAddressModal />}
      {changePasswordModal && <ChangePasswordModal />}
      {changePasswordRestoreModal && <ChangePasswordRestoreModal />}
      {changeEmailModal && <ChangeEmailModal />}
      {deleteProfileModal && <DeleteProfileModal />}
      {logOutModal && <LogoutModal />}
      {/* <FloatingCta showFloatingCta={showFloatingCta} /> */}
    </div>
  )
}